// extracted by mini-css-extract-plugin
export default {"fullWidth":"Xn-z","image":"Yn-z","lazyLoadPicture":"Zn-z","lazyLoadSpinner":"_n-z","lazyLoadSpin":"ao-z","lazyLoadImage":"bo-z","hasStyledAspectRatio":"co-z"};